import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_base_svg_icon = _resolveComponent("base-svg-icon")!

  return (_openBlock(), _createElementBlock("button", {
    class: "w-7 sm:w-8 lg:w-9",
    disabled: _ctx.btnDisabled,
    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.bookmarkSwitch()))
  }, [
    (_ctx.isBookmarked)
      ? (_openBlock(), _createBlock(_component_base_svg_icon, {
          key: 0,
          class: "text-red-400 animate__animated animate__bounceIn",
          path: _ctx.mdiBookmarkMinus
        }, null, 8, ["path"]))
      : (_openBlock(), _createBlock(_component_base_svg_icon, {
          key: 1,
          class: "text-gray-300 animate__animated animate__bounceIn",
          path: _ctx.mdiBookmarkPlus
        }, null, 8, ["path"]))
  ], 8, _hoisted_1))
}